export default __webpack_public_path__ + "static/media/mm.4c3ba8ba.svg";